import clsx from 'clsx';

type LockupProps = {
    className?: string;
    size?: 'default' | 'large';
    width?: number;
    height?: number;
};
export default function Lockup({ className, size = 'default', width = 340, height = 79 }: LockupProps) {
    return (
        <>
            {size === 'default' && (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 340 79"
                    className={clsx(className)}
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0 31.9084H75.9285L51.2287 77.9291L37.9625 53.2177L24.6962 77.9291L0 31.9084ZM33.0254 41.1104H16.3742L24.6998 56.6198L33.0254 41.1104ZM59.5543 41.1104H42.9031L51.2287 56.6198L59.5543 41.1104Z"
                        fill="white"
                    />
                    <path
                        d="M125.332 77.9291H75.9321L100.632 31.9084L125.332 77.9291ZM92.3063 68.7235H108.957L100.632 53.2142L92.3063 68.7235Z"
                        fill="white"
                    />
                    <path
                        d="M134.481 31.9084L161.927 54.9188V31.9084H171.076V77.9291L143.631 54.9188V77.9291H134.481V31.9084Z"
                        fill="white"
                    />
                    <path
                        d="M208.034 78.3866H196.6L182.559 52.1564H193.585L182.51 31.4475H214.072C226.972 31.4475 237.401 41.9396 237.401 54.9188C237.401 67.8981 226.972 78.3902 214.072 78.3902V68.7272C221.666 68.7272 227.793 62.5127 227.793 54.9224C227.793 47.3321 221.662 41.1176 214.072 41.1176H199.115L209.955 61.3656H198.93L208.034 78.3937V78.3866Z"
                        fill="white"
                    />
                    <path
                        d="M257.664 52.6174L246.55 31.9084H283.142V41.1104H262.924L273.992 61.8194H255.696V68.7235H277.65L283.138 77.9291H246.547V52.6174H257.66H257.664Z"
                        fill="white"
                    />
                    <path
                        d="M303.408 77.9291H294.259V52.6174H305.373L294.259 31.9084H340V38.8126C340 49.9944 332.04 59.3393 321.519 61.4084L330.392 77.9291H318.959L310.313 61.8229H303.405V77.9291H303.408ZM330.669 41.114H310.636L316.81 52.621H317.129C323.945 52.621 329.572 47.6501 330.669 41.114Z"
                        fill="white"
                    />
                    <path
                        d="M103.921 0.35376H107.025L116.775 13.2866V0.35376H120.991V20.9769H117.887L108.137 8.01196V20.9769H103.921V0.35376Z"
                        fill="white"
                    />
                    <path
                        d="M53.6333 0.35376H60.7477C65.3758 0.35376 67.9509 2.88743 67.9509 6.24661C67.9509 7.8976 67.102 9.7523 65.3438 10.5492C67.4537 11.196 68.8886 13.0543 68.8886 15.2342C68.8886 18.9757 66.5444 20.9805 61.1278 20.9805H53.6333V0.35376ZM60.6021 3.88804H57.8494V9.1019H60.6021C62.8859 9.1019 63.7348 8.12989 63.7348 6.47889C63.7348 4.82789 62.8859 3.88446 60.6021 3.88446V3.88804ZM57.8494 12.6398V17.4427H61.4794C63.7064 17.4427 64.5234 16.56 64.5234 15.0555C64.5234 13.551 63.7029 12.6398 61.4794 12.6398H57.8494Z"
                        fill="white"
                    />
                    <path
                        d="M90.1788 17.9144H81.3346L80.1625 20.9769H75.7688L84.0589 0.35376H87.4545L95.741 20.9769H91.3473L90.1752 17.9144H90.1788ZM82.6808 14.3801H88.8291L85.7531 6.36811L82.6772 14.3801H82.6808Z"
                        fill="white"
                    />
                    <path
                        d="M148.22 0.35376L140.693 11.0209L149.449 20.9805H144.178L136.36 11.9072V20.9805H132.144V0.35376H136.36V10.4885L143.3 0.35376H148.22Z"
                        fill="white"
                    />
                    <path
                        d="M156.773 5.59624C156.773 2.26565 159.117 0 163.361 0C165.322 0 167.343 0.528891 168.867 1.44373L167.578 4.8029C166.523 4.09533 165.116 3.65221 163.77 3.65221C161.926 3.65221 161.046 4.33119 161.046 5.39254C161.046 6.53966 161.806 7.23294 164.59 8.51586C168.178 10.1669 169.89 11.993 169.89 15.0877C169.89 18.89 167.311 21.3343 162.481 21.3343C160.342 21.3343 158.058 20.7161 156.332 19.6547L157.622 16.2384C158.939 17.1532 160.726 17.6821 162.307 17.6821C164.356 17.6821 165.617 16.8566 165.617 15.4272C165.617 13.9084 164.548 13.0543 162.029 11.9501C157.959 10.1669 156.773 8.26571 156.773 5.59981V5.59624Z"
                        fill="white"
                    />
                    <path
                        d="M183.128 3.94879H177.651V0.35376H192.821V3.94879H187.344V20.9769H183.128V3.94879Z"
                        fill="white"
                    />
                    <path
                        d="M211.71 0C217.858 0 222.692 4.42053 222.692 10.6672C222.692 16.9138 217.862 21.3343 211.71 21.3343C205.558 21.3343 200.727 16.9138 200.727 10.6672C200.727 4.42053 205.558 0 211.71 0ZM211.71 17.6785C215.429 17.6785 218.416 14.8197 218.416 10.6672C218.416 6.51465 215.429 3.65578 211.71 3.65578C207.991 3.65578 205.004 6.51465 205.004 10.6672C205.004 14.8197 207.991 17.6785 211.71 17.6785Z"
                        fill="white"
                    />
                    <path
                        d="M251.477 14.0835L255.604 0.35376H259.998L253.174 20.9769H249.779L245.151 7.01135L240.523 20.9769H237.127L230.304 0.35376H234.698L238.825 14.0835L243.453 0.35376H246.849L251.477 14.0835Z"
                        fill="white"
                    />
                    <path
                        d="M269.076 0.35376H272.181L281.93 13.2866V0.35376H286.146V20.9769H283.042L273.292 8.01196V20.9769H269.076V0.35376Z"
                        fill="white"
                    />
                </svg>
            )}
            {size === 'large' && (
                <svg
                    width="637"
                    height="146"
                    viewBox="0 0 637 146"
                    className={clsx(className)}
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M0 59.3298H142.042L95.8354 144.899L71.0178 98.9517L46.2001 144.899L0 59.3298ZM61.7817 76.4397H30.6317L46.2067 105.277L61.7817 76.4397ZM111.41 76.4397H80.2604L95.8354 105.277L111.41 76.4397Z"
                        fill="white"
                    />
                    <path
                        d="M234.462 144.899H142.049L188.256 59.3298L234.462 144.899ZM172.681 127.783H203.831L188.256 98.9451L172.681 127.783Z"
                        fill="white"
                    />
                    <path
                        d="M251.579 59.3298L302.922 102.115V59.3298H320.039V144.899L268.696 102.115V144.899H251.579V59.3298Z"
                        fill="white"
                    />
                    <path
                        d="M389.176 145.75H367.786L341.52 96.9783H362.145L341.427 58.4727H400.471C424.605 58.4727 444.113 77.9813 444.113 102.115C444.113 126.248 424.605 145.756 400.471 145.756V127.789C414.678 127.789 426.14 116.234 426.14 102.121C426.14 88.008 414.671 76.453 400.471 76.453H372.491L392.77 114.101H372.145L389.176 145.763V145.75Z"
                        fill="white"
                    />
                    <path
                        d="M482.021 97.8354L461.23 59.3298H529.683V76.4397H491.862L512.566 114.945H478.34V127.783H519.41L529.676 144.899H461.223V97.8354H482.014H482.021Z"
                        fill="white"
                    />
                    <path
                        d="M567.597 144.899H550.481V97.8354H571.272L550.481 59.3298H636.05V72.1673C636.05 92.9583 621.16 110.334 601.478 114.181L618.076 144.899H596.687L580.514 114.952H567.591V144.899H567.597ZM618.595 76.4464H581.119L592.667 97.8421H593.265C606.016 97.8421 616.542 88.5994 618.595 76.4464Z"
                        fill="white"
                    />
                    <path
                        d="M194.409 0.657715H200.216L218.456 24.7046V0.657715H226.343V39.0039H220.535L202.296 14.8971V39.0039H194.409V0.657715Z"
                        fill="white"
                    />
                    <path
                        d="M100.334 0.657715H113.643C122.301 0.657715 127.118 5.36876 127.118 11.6147C127.118 14.6845 125.53 18.1331 122.241 19.6148C126.188 20.8175 128.873 24.2727 128.873 28.3259C128.873 35.2829 124.487 39.0105 114.354 39.0105H100.334V0.657715ZM113.371 7.22925H108.221V16.9238H113.371C117.643 16.9238 119.231 15.1164 119.231 12.0466C119.231 8.97679 117.643 7.22261 113.371 7.22261V7.22925ZM108.221 23.5019V32.4323H115.012C119.178 32.4323 120.706 30.7911 120.706 27.9937C120.706 25.1963 119.171 23.5019 115.012 23.5019H108.221Z"
                        fill="white"
                    />
                    <path
                        d="M168.701 33.3094H152.156L149.963 39.0039H141.744L157.252 0.657715H163.604L179.106 39.0039H170.887L168.694 33.3094H168.701ZM154.674 26.7379H166.176L160.422 11.8406L154.667 26.7379H154.674Z"
                        fill="white"
                    />
                    <path
                        d="M277.28 0.657715L263.2 20.4919L279.579 39.0105H269.719L255.094 22.1398V39.0105H247.207V0.657715H255.094V19.5019L268.077 0.657715H277.28Z"
                        fill="white"
                    />
                    <path
                        d="M293.28 10.4055C293.28 4.21269 297.666 0 305.606 0C309.274 0 313.055 0.983405 315.905 2.68443L313.493 8.93038C311.52 7.61474 308.889 6.79081 306.37 6.79081C302.922 6.79081 301.274 8.05329 301.274 10.0267C301.274 12.1597 302.696 13.4487 307.905 15.8341C314.616 18.904 317.819 22.2994 317.819 28.0536C317.819 35.1235 312.995 39.6684 303.958 39.6684C299.958 39.6684 295.686 38.5189 292.457 36.5454L294.869 30.1932C297.334 31.8942 300.676 32.8776 303.633 32.8776C307.467 32.8776 309.826 31.3427 309.826 28.6849C309.826 25.8609 307.826 24.2728 303.115 22.2196C295.5 18.904 293.28 15.369 293.28 10.4121V10.4055Z"
                        fill="white"
                    />
                    <path
                        d="M342.584 7.34221H332.338V0.657715H360.717V7.34221H350.471V39.0039H342.584V7.34221Z"
                        fill="white"
                    />
                    <path
                        d="M396.053 0C407.555 0 416.598 8.2194 416.598 19.8342C416.598 31.449 407.561 39.6684 396.053 39.6684C384.544 39.6684 375.508 31.449 375.508 19.8342C375.508 8.2194 384.544 0 396.053 0ZM396.053 32.871C403.01 32.871 408.598 27.5553 408.598 19.8342C408.598 12.1132 403.01 6.79745 396.053 6.79745C389.096 6.79745 383.508 12.1132 383.508 19.8342C383.508 27.5553 389.096 32.871 396.053 32.871Z"
                        fill="white"
                    />
                    <path
                        d="M470.447 26.1864L478.168 0.657715H486.387L473.623 39.0039H467.27L458.612 13.0367L449.954 39.0039H443.602L430.838 0.657715H439.057L446.778 26.1864L455.436 0.657715H461.789L470.447 26.1864Z"
                        fill="white"
                    />
                    <path
                        d="M503.37 0.657715H509.178L527.417 24.7046V0.657715H535.304V39.0039H529.497L511.257 14.8971V39.0039H503.37V0.657715Z"
                        fill="white"
                    />
                </svg>
            )}
        </>
    );
}
